// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__WFPVd","active":"Cell_active__2v3O9"};